import gql from 'graphql-tag';

const ACTIVE_STATUS_NETWORK = gql`
  {
    snackBatStatusNetwork @client
  }
`;

export default ACTIVE_STATUS_NETWORK;